// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"87391226","47":"6f9b04e7","168":"cbd00114","396":"e0240847","514":"0f5afb81","655":"493e975e"}[chunkId] + ".chunk.css";
};